import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { Title, Meta } from '@angular/platform-browser';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import {SeoService} from "../seo-service.service";

@Component({
    selector: 'app-enquire',
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatProgressSpinnerModule,
    MatDialogModule
  ],
    templateUrl: './enquire.component.html',
    styleUrl: './enquire.component.scss'
})

export class EnquireComponent implements OnInit {
  contactForm: FormGroup;
  isSubmitting = false;

  constructor(
    private fb: FormBuilder,
    private snackBar: MatSnackBar,
    private dialog: MatDialog,
    private seo: SeoService,
  ) {
    this.contactForm = this.fb.group({
      name: ['', [Validators.required]],
      email: ['', [Validators.email]],
      phone: [''],
      message: ['', [Validators.required, Validators.minLength(10)]]
    });
  }

  // generate email
  onSubmit(): void {
    if (this.contactForm.valid) {
      this.isSubmitting = true;

      // Get form values
      const formValues = this.contactForm.value;

      // Set email recipient
      const emailTo = 'reception506@svha.org.au'; // Use the email from the HTML comment

      // Create subject line
      const subject = `Website Inquiry from: ${formValues.name}`;

      // Create email body
      let body = `Name: ${formValues.name}\n`;
      body += `Email: ${formValues.email}\n`;
      body += `Phone: ${formValues.phone || 'Not provided'}\n\n`;

      body += `Message:\n${formValues.message}`;

      // Create mailto URL with encoded parameters
      const mailtoUrl = `mailto:${emailTo}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;

      // Open default email client
      window.location.href = mailtoUrl;

      setTimeout(() => {

        // Reset form properly
        this.contactForm.reset();

        // Reset validation state
        Object.keys(this.contactForm.controls).forEach(key => {
          const control = this.contactForm.get(key);
          control?.markAsUntouched();
          control?.markAsPristine();
        });

        this.isSubmitting = false;

        // Refresh the page
        window.location.reload();

      }, 1000);
    }
  }
  // for crawlers
  ngOnInit() {
    this.seo.updateMeta(
      "Send an Enquiry | Sydney Advanced Endocrinology",
      "Have a question or need to book an appointment? Send your enquiry to Sydney Advanced Endocrinology using our secure online form."
    );
  }
}

@Component({
  selector: 'thank-you-dialog',
  template: `
    <div class="thank-you-container">
      <h2 mat-dialog-title>Thank You!</h2>
      <mat-dialog-content>
        <p>Your message has been received. We appreciate your inquiry and will get back to you as soon as possible.</p>
      </mat-dialog-content>
      <mat-dialog-actions align="end">
        <button mat-button mat-dialog-close color="primary">Close</button>
      </mat-dialog-actions>
    </div>
  `,
  styles: [`
    .thank-you-container {
      text-align: center;
      padding: 1rem;
    }
    h2 {
      color: #2e7d32;
    }
  `],
  standalone: true,
  imports: [MatDialogModule, MatButtonModule]
})
export class ThankYouDialogComponent {}
